import React from 'react';
import {BsCheckCircleFill} from "react-icons/bs";

const Amenities = ({...props}) => {
    const amenitiesData = props.amenitiesData;
    
    return (
        <>{amenitiesData.length > 0 &&
        <div className='flex flex-col mb-4'>
            <h3 className='font-semibold text-gray-800 underline mb-2'>{props.title}</h3>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-2 leading-4'>
                {amenitiesData.map((amenititescontent)=>{
                    return (
                    <div className='flex items-start space-x-2 my-1' key={amenititescontent.id}><BsCheckCircleFill className='fill-orange-300' /> <span>{amenititescontent.text}</span></div>
                    )
                })}
            </div>
        </div>
        }</>
    );
}

export default Amenities;